module.exports = __webpack_public_path__ + "static/media/DownCaret.48e70848.svg";